import Button from "../../../components/button";
import Table from "../../../components/table";
import { Agreement } from "../../../dto/agreement.dto";
import { dateToDDMMYYYYHHMMAP } from "../../../utils";

interface AgreementsTableProps {
  userAgreements: Array<Agreement>;
  previewFn: (agreementId: string) => void;
}

export default function AgreementsTable({
  userAgreements,
  previewFn,
}: AgreementsTableProps) {
  return (
    <div className="dashboard-container">
      <h4>Agreements</h4>
      <Table
        columns={[
          { field: "entityId", label: "Entity ID" },
          { field: "agreementType", label: "Agreement type" },
          {
            field: "createdAt",
            label: "Created on",
          },
          {
            // RBI AUDIT: Agreement must be previewed in-portal instead of
            // downloaded to the user's device.
            field: "preview",
            label: "Preview",
            style: { textAlign: "center" },
          },
        ]}
        data={userAgreements.map((el) => {
          return {
            ...el,
            createdAt: dateToDDMMYYYYHHMMAP(el.createdAt),
            agreementType: el.agreementType.includes("CREDIT_LINE")
              ? "EWA_LOAN_AGREEMENT"
              : el.agreementType,
            preview: (
              <Button
                variant="blue"
                onClick={() => {
                  previewFn(el._id);
                }}
              >
                <span className="text__underline">Preview</span>
              </Button>
            ),
          };
        })}
      />
    </div>
  );
}
